// Module
var code = "<div v-for=\"filter in filters\" class=\"col-12 col-lg-6\"> <Filter :name=\"filter.name\" :options=\"filter.options\" :selectedFilter=\"selectedFilter\" @filter-changed=\"changeFilter\"></Filter> </div> ";
// Exports
export default code;